import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2fgt3byexw: FaireBrandEntity = {
  token: "b_2fgt3byexw",
  type: "brand",
  name: "TheDivaSoap",
  avatarUrl:
    "https://cdn.faire.com/fastly/93ed3ac4ba757b66e9174d8efad67be0fb492d40f9bfa98ce9f9bdb594631154.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5067549b71333cc5d5554d790b02d9fe0c4f9c03c6e6dd3c276d6f6bc3a0b0d4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/93ed3ac4ba757b66e9174d8efad67be0fb492d40f9bfa98ce9f9bdb594631154.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5067549b71333cc5d5554d790b02d9fe0c4f9c03c6e6dd3c276d6f6bc3a0b0d4.jpeg",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 167,
  isTopShop: true,
  isInsider: true,
  description:
    "TheDivaSoap is a creative and vibrant accessory brand that brings color and personality to every piece we create. We specialize in providing high-quality, eco-friendly acetate hair accessories and offer a wide range of affordable yet stylish accessories.\n\nAll of our products are made-to-order, ensuring careful attention to detail and quality in every piece. With our own in-house manufacturing facility, we are also able to offer flexible customization services. Whether you need bespoke hair clips, added branding elements, or your own logo incorporated into the design, we are happy to tailor products to your specific requirements.\n\nCurrently, our delivery times range from 1 to 3 weeks, depending on the size of the order. With over 80 Faire retailers, we take the time needed to carefully process each order to ensure the best possible experience.\n\nTax Notice: Orders shipped to addresses within the United States are not subject to additional taxes. International orders (outside the U.S.) may incur duties or taxes according to the regulations of the destination country.\n\nIf you have any special requests or specific requirements for your order, please feel free to let us know—we will do our best to accommodate your needs.\n\nThank you for your support!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:05.502Z",
    importedBy: "entity-db-cli",
  },
};
